export function setAudioSounds(state, action) {

  const newState = {...state};
  newState.audio.sounds = action.data.map(item=>Object.assign([],item));

  return newState;
}


// WEBPACK FOOTER //
// ./src/reducers/audio.js